/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';

const ROOT_STORE_SOURCE = '[Root Store]';

export const setLoading = createAction(
    `${ROOT_STORE_SOURCE} Set Loading`,
    props<{ loading: boolean }>(),
);
